package de.oevbs.kunde.kundenportal2.model.services.inbox

import de.oevbs.kunde.kundenportal2.ServiceInfo
import de.oevbs.sfa.communication.ClientDefinition
import de.oevbs.sfa.communication.ClientResponse

abstract class InboxClientDefinition(origin: String) : ClientDefinition(ServiceInfo, origin, ServiceInfo.name) {

    override val requestTimeoutMillis: Long = 30000L

    /**
     * Läd alle eingehenden, für Kunden zulässige Kontakte und Nachrichten des eingeloggten Users/Partners, die
     * im Zeitraum von [fromTo] im CRM vorhanden sind.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun messages(fromTo: FromTo): ClientResponse<List<Message>> = post("/inbox/messages", fromTo)

    /**
     * Läd die Nachrichtendetails der Nachricht mit Id [id] und markiert die Nachricht im CRM als gelesen.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun messageById(id: String): ClientResponse<Message> = get("/inbox/message/${id}")
}